import { useTranslation } from "react-i18next";
import { useDispatch , useSelector} from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "../../../store/store";
import { RequestState } from "../../../models/RequestState";
import { CoreObjectLogs } from "../../../models/CoreObjectLogs";
import { useEffect } from "react";
import { GetObjectLogs } from "../../../store/ObjectLogAction";
import * as LogTypes from '../../../util/FlowSyncLoggerTypes';
import ObjectLogs from "../../misc/ObjectLogs";
import React from "react";

const DeviceViewObjectLogs = () => {
    const { t } = useTranslation('device');

    const { deviceId } = useParams();
    const dispatch = useDispatch();
    const objectLogs = useSelector<RootState, RequestState<CoreObjectLogs[]>>(state => state.objectLog.objectLogs);

    useEffect(() => {
        if (deviceId) {
            GetObjectLogs({ objectId: deviceId, objectSource: LogTypes.Flowsync.SourceName, objectType: LogTypes.Flowsync.GoogleDevice })(dispatch);
        }
    }, [dispatch, deviceId]);

    return (<>
        <ObjectLogs
            objectLogs={objectLogs}
            noResMsg={t('device.objectLogs.noResult', { ns: 'device' })}
        />
    </>);
}

export default DeviceViewObjectLogs;